import { render, staticRenderFns } from "./MomoNotification.vue?vue&type=template&id=708c26b5&scoped=true"
import script from "./MomoNotification.vue?vue&type=script&lang=js"
export * from "./MomoNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c26b5",
  null
  
)

export default component.exports